module.exports = __webpack_public_path__ + "img/logo.481dfce1.png";